




























import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { BranchOperatingZone } from '@/api/model/branch-operating-zone'

@Component
export default class CopyBranchOperatingZonesModal extends Vue {

    @Prop({ type: Boolean, default: false }) value!: boolean
    @Prop({ type: Array, default() { return [] } }) operatingZones!: BranchOperatingZone[]
    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    hideModal(): void {
        this.visible = false
    }

    async copy(): Promise<void> {
        await navigator.clipboard.writeText(this.operatingZonesString)

        this.hideModal()
    }

    get operatingZonesString(): string {
        return this.operatingZones.map(operatingZone => operatingZone.areaCode).join(', ')
    }

}
